import { getConfig } from '@constants';

import { IShowcase, IShowcaseData } from '@stores';

import { IShowcaseResponse, EShowcaseType, IShowcaseResponseBannerData } from '@interfaces/api';

export const getAdaptedShowcase = (appsResp: IShowcaseResponse[]): IShowcaseData => {
	const apps = appsResp.map((showcase: IShowcaseResponse, i: number): IShowcase => {
		const showcaseData = showcase.data;
		const appsPathname = getConfig().apps?.pathname;
		let data;

		switch (showcase.type) {
			case EShowcaseType.APP:
				if ('ID' in showcaseData) {
					data = {
						id: showcaseData.ID,
						url: `${appsPathname}/${showcaseData.ID}`,
						title: showcaseData.Name,
						description: showcaseData.Description,
						pics: {
							'753x423': showcaseData.Pictures?.BananaWheelPMM17139N1 || showcaseData.Pictures?.GameCover,
						},
						source: showcase.source,
						type: showcase.type,
					};
				}
				break;
			case EShowcaseType.BANNER:
				const showcaseBannerData = showcase.data as IShowcaseResponseBannerData;

				data = {
					id: showcaseBannerData.banner || showcaseBannerData.desc + '_' + showcaseBannerData.title,
					title: showcaseBannerData.title,
					description: showcaseBannerData.desc,
					url: showcaseBannerData?.button?.type === 'url' ? showcaseBannerData?.button?.url : undefined,
					pics: {
						'753x423': showcaseBannerData.pic,
					},
					source: showcase.source,
					type: showcase.type,
				};
				break;
			case EShowcaseType.PLATFORM:
				if ('action' in showcaseData) {
					const actionInfo = showcaseData['action_info'];

					data = {
						id: actionInfo.ActionID,
						title: actionInfo.title,
						description: actionInfo.desc,
						url: actionInfo?.['BannerThemeOptions_showcase']?.button?.type === 'url'
							? actionInfo?.['BannerThemeOptions_showcase']?.button?.url
							: undefined,
						pics: {
							'753x423': actionInfo.pic || showcaseData.pic,
						},
						source: showcase.source,
						type: showcase.type,
					};
				}
				break;
		}

		if ('button' in showcaseData) {
			data = {
				...data,
				button: {
					text: showcaseData.button.text,
					type: showcaseData.button.type,
					url: showcaseData.button.url,
				},
			};
		}

		return data;
	}).filter((data: IShowcase) => data !== undefined);

	return { apps };
};
